import React, { useState, useRef, useEffect } from "react";
import "../../css/components/Navbar.css";
import logo from "../../assets/icons/navbar_logo.svg";
import SecondaryButton from "./buttons/SecondaryButton";
import { useNavigate } from "react-router-dom";

const Navbar = () => {
  const navigate = useNavigate();
  const [showServicesDropdown, setShowServicesDropdown] = useState(false);
  const [showCalculatorsDropdown, setShowCalculatorsDropdown] = useState(false);
  const servicesRef = useRef(null);
  const calculatorsRef = useRef(null);

  // Close dropdown if clicked outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (servicesRef.current && !servicesRef.current.contains(event.target)) {
        setShowServicesDropdown(false);
      }
      if (
        calculatorsRef.current &&
        !calculatorsRef.current.contains(event.target)
      ) {
        setShowCalculatorsDropdown(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const servicesList = [
    { name: "Wealth Management", path: "/services/wealth-management" },
    { name: "Taxation", path: "/services/taxation" },
    { name: "Mortgages", path: "/services/mortgages" },
    { name: "Savings/Investments", path: "/services/savings-investments" },
    { name: "Protection", path: "/services/protection" },
    { name: "Equity Release", path: "/services/equity-release" },
  ];

  const calculatorsList = [
    { name: "Mortgage Borrow", path: "/calculators/mortgage-borrow" },
    { name: "Mortgage Repayment", path: "/calculators/mortgage-repayment" },
    { name: "Overpayment", path: "/calculators/overpayment" },
    { name: "Stamp Duty", path: "/calculators/stamp-duty" },
    {
      name: "How Much Will It Cost",
      path: "/calculators/how-much-will-it-cost",
    },
    {
      name: "How Much Can I Borrow",
      path: "/calculators/how-much-can-i-borrow",
    },
    { name: "Equity Release", path: "/calculators/equity-release" },
    { name: "Relevant Life Tax", path: "/calculators/relevant-life-tax" },
    { name: "Pensions Shortfall", path: "/calculators/pensions-shortfall" },
    { name: "Inheritance Tax", path: "/calculators/inheritance-tax" },
    { name: "Investment", path: "/calculators/investment" },
  ];

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <img
          src={logo}
          alt="Merrick Platts Logo"
          className="navbar-logo"
          onClick={() => {
            navigate("/");
          }}
        />
      </div>
      <ul className="navbar-links">
        <li>
          <span
            className="button-text"
            onClick={() => {
              navigate("/about-us");
            }}
          >
            About Us
          </span>
        </li>
        <li ref={servicesRef} style={{ position: "relative" }}>
          <span
            className="button-text"
            onClick={() => setShowServicesDropdown((prev) => !prev)}
            style={{ userSelect: "none" }}
          >
            Services
          </span>
          {showServicesDropdown && (
            <ul className="navbar-dropdown">
              {servicesList.map((service) => (
                <li
                  key={service.name}
                  className="navbar-dropdown-item content"
                  onClick={() => {
                    setShowServicesDropdown(false);
                    navigate(service.path);
                  }}
                >
                  {service.name}
                </li>
              ))}
            </ul>
          )}
        </li>
        <li ref={calculatorsRef} style={{ position: "relative" }}>
          <span
            className="button-text"
            onClick={() => setShowCalculatorsDropdown((prev) => !prev)}
            style={{ userSelect: "none" }}
          >
            Calculators
          </span>
          {showCalculatorsDropdown && (
            <ul className="navbar-dropdown">
              {calculatorsList.map((calc) => (
                <li
                  key={calc.name}
                  className="navbar-dropdown-item content"
                  onClick={() => {
                    setShowCalculatorsDropdown(false);
                    navigate(calc.path);
                  }}
                >
                  {calc.name}
                </li>
              ))}
            </ul>
          )}
        </li>
        <li>
          <span
            className="button-text"
            onClick={() => {
              navigate("/faqs");
            }}
          >
            FAQ
          </span>
        </li>
        <li>
          <span
            className="button-text"
            onClick={() => {
              navigate("/contact-us");
            }}
          >
            Contact Us
          </span>
        </li>
      </ul>
      <SecondaryButton
        onClick={() => {
          navigate("/contact-us");
        }}
        text="Speak to Us"
      />
    </nav>
  );
};

export default Navbar;
